import { useState } from 'react';
import { Alert, Text } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

interface MitigationAlertProps {
  pendingCount: number;
}

export const MitigationAlert = ({ pendingCount }: MitigationAlertProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) {
    return null;
  }

  return (
    <Alert
      variant="outline"
      severity="info"
      isClosable
      onClose={() => setIsOpen(false)}
    >
      <Text>
        {t('operations.euq.mitigation.additionalMessagesAlert', {
          count: pendingCount,
        })}
      </Text>
    </Alert>
  );
};
